"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FillInTheBlank = void 0;
const react_1 = __importStar(require("react"));
const types_1 = require("../../gameplay/types");
const FillInTheBlankCell_1 = require("./FillInTheBlankCell");
const AttributedTypography_1 = require("./AttributedTypography");
const react_2 = require("@emotion/react");
const utils_1 = require("../../utils");
class PartInfo {
    constructor(part) {
        this.partString = part;
    }
}
class BlankPartInfo extends PartInfo {
    constructor(part, expectedInput, blankIndex) {
        super(part);
        this.currentInput = '';
        this.isActive = false;
        this.currentExpectedInput = expectedInput;
        this.blankIndex = blankIndex;
    }
}
function FillInTheBlank(props) {
    const [parts, setParts] = (0, react_1.useState)([]);
    const [partInfoArr, setPartInfoArr] = (0, react_1.useState)([]);
    const [activePartIndex, setActivePartIndex] = (0, react_1.useState)(-1);
    const [size, setSize] = (0, react_1.useState)('md');
    (0, react_1.useEffect)(() => {
        function handleResize() {
            const width = window.innerWidth;
            if (width < 768) {
                setSize('sm');
            }
            else if (width < 1280) {
                setSize('md');
            }
            else {
                setSize('lg');
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize(); // Call initially to set the size
        return () => window.removeEventListener('resize', handleResize); // Clean up
    }, []);
    (0, react_1.useEffect)(() => {
        // create parts
        const parts = splitStringWithSeparators(props.text);
        setParts(parts);
        // generate part info array
        const arr = generatePartsInfoArr(props.inputMode, parts, props.inputs, props.expectedInputs, props.activeInputIndex);
        setPartInfoArr(arr);
        // select active index based on parts
        const index = decideActivePartIndex(arr);
        setActivePartIndex(index);
    }, [
        props.text,
        props.inputMode,
        props.inputs,
        props.expectedInputs,
        props.activeInputIndex,
    ]);
    return (react_1.default.createElement("div", { className: "flex flex-wrap sm:flex-row gap-1 justify-center", style: {
            alignItems: props.displayMode === 'UNDERSCORE' ? 'baseline' : 'center',
        } }, parts.map((part, index) => {
        if (part === '{}' || part === '^{}' || part === '_{}') {
            const partInfo = partInfoArr[index];
            const input = partInfo.currentInput;
            const expectedInput = partInfo.currentExpectedInput;
            return (react_1.default.createElement(FillInTheBlankCell_1.FillInTheBlankCell, { key: index, blankIndex: partInfo.blankIndex, input: input, expectedInput: getExpectedInputForCell(props.inputMode, input, expectedInput, props.gameplayControl), inputMode: props.inputMode, displayMode: getBlankCellDisplayMode(part, props.displayMode), size: getBlankCellSize(part, size), gameplayControl: props.gameplayControl, gameplayStyle: props.gameplayStyle, active: activePartIndex === index ? true : false, onInteract: blankIndex => {
                    if (props.onInteract) {
                        props.onInteract(blankIndex);
                    }
                } }));
        }
        return (react_1.default.createElement(react_2.ThemeProvider, { theme: (0, utils_1.getTheme)(props.gameplayStyle), key: index },
            react_1.default.createElement(AttributedTypography_1.AttributedTypography, { variant: "h5", sx: {
                    color: getNonBlankColor(props.gameplayStyle, props.gameplayControl),
                    textAlign: 'start',
                    // fontSize: `${getFontSize(size)}px`,
                    fontFamily: 'Bryant',
                    fontWeight: 700,
                    lineHeight: '28px',
                    fontStyle: 'normal',
                }, onClick: () => {
                    if (props.onInteractNonBlank) {
                        props.onInteractNonBlank();
                    }
                } }, part)));
    })));
}
exports.FillInTheBlank = FillInTheBlank;
function getExpectedInputForCell(inputMode, input, expectedInput, gameplayControl) {
    const answerControls = [
        types_1.GameplayControl.PresentAnswerWithCorrectResponse,
        types_1.GameplayControl.PresentAnswerWithIncorrectResponse,
    ];
    if (answerControls.includes(gameplayControl)) {
        return expectedInput;
    }
    switch (inputMode) {
        case 'FULL_TEXT': {
            if (input.length === 0) {
                return expectedInput;
            }
            else {
                return input;
            }
        }
        case 'SPELLING': {
            return expectedInput;
        }
    }
}
function splitStringWithSeparators(inputString) {
    const separators = [
        '\\{\\}', // Matches {} literally
        '\\^\\{\\}', // Matches ^{} literally
        '\\_\\{\\}', // Matches _{} literally
        '\\s+',
    ];
    const regex = new RegExp(`(${separators.join('|')})`, 'g'); // Create regex with capturing group
    const result = [];
    let lastIndex = 0; // Keep track of where we've processed
    let match;
    while ((match = regex.exec(inputString)) !== null) {
        result.push(inputString.substring(lastIndex, match.index)); // Text before separator
        result.push(match[0]); // The separator itself
        lastIndex = match.index + match[0].length; // Update lastIndex
    }
    result.push(inputString.substring(lastIndex)); // Add the remaining text
    return result.filter(part => part !== ''); // Remove any empty strings
}
function getBlankCellSize(part, size) {
    switch (part) {
        case '{}':
            return size;
        case '^{}':
        case '_{}':
            switch (size) {
                case 'lg':
                    return 'md';
                case 'md':
                    return 'sm';
                case 'sm':
                    return 'xs';
                case 'xs':
                    return 'xs';
            }
    }
}
function getBlankCellDisplayMode(part, displayMode) {
    switch (part) {
        case '{}':
            return displayMode === 'UNDERSCORE' ? 'UNDERLINE' : 'SQUARE_NORMAL';
        case '^{}':
            return 'SQUARE_SUPERSCRIPT';
        case '_{}':
            return 'SQUARE_SUBSCRIPT';
    }
}
// function getFontSize(size: 'lg' | 'md' | 'sm' | 'xs') {
//   switch (size) {
//     case 'lg':
//       return 48;
//     case 'md':
//       return 36;
//     case 'sm':
//       return 24;
//     case 'xs':
//       return 12;
//   }
// }
function getNonBlankColor(gameplayStyle, gameplayControl) {
    switch (gameplayControl) {
        case types_1.GameplayControl.PresentQuestion:
        case types_1.GameplayControl.Pending:
        case types_1.GameplayControl.PresentAnswerWithCorrectResponse:
        case types_1.GameplayControl.PresentAnswerWithIncorrectResponse:
            switch (gameplayStyle) {
                case types_1.GameplayStyle.PopStudy:
                    return 'black';
                default:
                    return 'white';
            }
    }
}
function decideActivePartIndex(partInfoArr) {
    if (partInfoArr.length === 0) {
        return -1;
    }
    let index = -1;
    for (const partInfo of partInfoArr) {
        index += 1;
        if (partInfo instanceof BlankPartInfo) {
            if (partInfo.isActive) {
                break;
            }
        }
    }
    return index;
}
function generatePartsInfoArr(inputMode, parts, inputs, expectedInputs, activeInputIndex) {
    const arr = [];
    const mutalbeInputs = [...inputs];
    const mutableExpectedInputs = [...expectedInputs];
    let blankIndexCounter = -1;
    parts.forEach(part => {
        if (part === '{}' || part === '^{}' || part === '_{}') {
            const splicedInputs = mutalbeInputs.splice(0, 1);
            const splicedExpectedInputs = mutableExpectedInputs.splice(0, 1);
            const input = splicedInputs.length > 0 ? splicedInputs[0] : '';
            const expectedInput = splicedExpectedInputs.length > 0 ? splicedExpectedInputs[0] : '';
            if (splicedExpectedInputs.length > 0) {
                blankIndexCounter += 1;
            }
            const blankPartInfo = new BlankPartInfo(part, expectedInput, blankIndexCounter);
            blankPartInfo.currentInput = input;
            if (blankIndexCounter === activeInputIndex) {
                blankPartInfo.isActive = true;
            }
            arr.push(blankPartInfo);
        }
        else {
            const partInfo = new PartInfo(part);
            arr.push(partInfo);
        }
    });
    return arr;
}
